import { Box, Stack } from "@mui/material";
import { type ClipboardScoreLog } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreHistory";
import { type ClipboardScorePolicy } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { Divider, Text } from "@src/appV2/redesign/system/ui-components";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";

import { Button } from "../../../components/Button";
import { CLIPBOARD_SCORE_HISTORY_FULL_PATH } from "../../utils/paths";
import { ActivityItemForLog } from "../Activity/ItemForLog";

interface HistoryProps {
  logs: ClipboardScoreLog[];
  isDynamicPenaltiesEnabled: boolean;
  policy?: ClipboardScorePolicy;
  isEmergencyCreditsEnabled?: boolean;
}

export function History({
  logs,
  isDynamicPenaltiesEnabled,
  policy,
  isEmergencyCreditsEnabled,
}: HistoryProps) {
  const history = useHistory();

  if (logs.length === 0) {
    return null;
  }

  return (
    <Stack spacing={4} sx={{ paddingY: 6 }}>
      <Text bold variant="h5">
        History
      </Text>
      <Divider color="primary" />
      <Box paddingTop={5}>
        <Stack direction="column" spacing={5}>
          {!isEmpty(logs[0].shiftId) && (
            <Text bold color={(theme) => theme.palette.text.disabled}>
              Last shift
            </Text>
          )}
          {logs.map((log) => {
            const id = `history-${log.id}`;

            return (
              <ActivityItemForLog
                key={id}
                id={id}
                log={log}
                isDynamicPenaltiesEnabled={isDynamicPenaltiesEnabled}
                showDetails={false}
                policy={policy}
                isEmergencyCreditsEnabled={isEmergencyCreditsEnabled}
              />
            );
          })}
        </Stack>
      </Box>
      <Button
        variant="outlined"
        onClick={() => {
          history.push(CLIPBOARD_SCORE_HISTORY_FULL_PATH);
        }}
      >
        Show all activity
      </Button>
    </Stack>
  );
}
